import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  REPORTS_RESET_REPORTS_DATA_ACCOUNT,
} from './constants';

export function resetReportsDataAccount() {
  return {
    type: REPORTS_RESET_REPORTS_DATA_ACCOUNT,
  };
}

export function useResetReportsDataAccount() {
  const dispatch = useDispatch();
  const boundAction = useCallback((...params) => dispatch(resetReportsDataAccount(...params)), [dispatch]);
  return { resetReportsDataAccount: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_RESET_REPORTS_DATA_ACCOUNT:
      return {
        ...state,
        reportsDataAccount: null,
        reportsTotalsAccount: 0,
        summaryAccount: null,
      };

    default:
      return state;
  }
}
